<template lang="pug">
    div.fit-truncate-text-control
        div.fit-truncate-text-control__ellipsis(ref='ellipsis')
            slot
            resize-sensor(@resize='resizeHeight')
        resize-sensor(@resize='resize')
</template>

<script>
import $ from 'jquery'

export default {
    name: 'fit-truncate-text-control',
    methods: {
        resize() {
            this.getEllipsisEl().css('width', `${this.getRootEl().width()}px`)
        },
        resizeHeight() {
            this.getRootEl().css('height', `${this.getEllipsisEl().height()}px`)
        },
        getRootEl() {
            return $(this.$el)
        },
        getEllipsisEl() {
            return $(this.$refs.ellipsis)
        },
    },
}
</script>
